// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import Dayjs from "dayjs";
import * as Belt_Int from "../../../../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Belt_Float from "../../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as CookieHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as GeoLocationHelper$PorterinFeature from "./GeoLocationHelper.mjs";
import * as CreateDilPayloadEntityMapper$PorterinFeature from "../entity-mapper/CreateDilPayloadEntityMapper.mjs";

function optionStringtoFloat(string) {
  return Belt_Option.getWithDefault(Belt_Float.fromString(Belt_Option.getWithDefault(string, "0.0")), 0.0);
}

function optionStringtoInt(string) {
  return Belt_Option.getWithDefault(Belt_Int.fromString(Belt_Option.getWithDefault(string, "0")), 0);
}

function createDilPayload(dil_uuid) {
  return JSON.stringify(CreateDilPayloadEntityMapper$PorterinFeature.execute({
                  dil_uuid: dil_uuid,
                  timestamp: Dayjs().unix()
                }));
}

function orderReviewProviderValue(state, dispatch) {
  return {
          query_params: state.query_params,
          set_query_params: (function (query_params) {
              Curry._1(dispatch, {
                    TAG: /* SetQueryParam */0,
                    _0: query_params
                  });
            }),
          is_valid_params: state.is_valid_params,
          geo_region_id: state.geo_region_id,
          set_geo_region_id: (function (geo_region_id) {
              Curry._1(dispatch, {
                    TAG: /* SetGeoRegionId */4,
                    _0: geo_region_id
                  });
            }),
          is_retry: state.is_retry,
          set_is_retry: (function (retry) {
              Curry._1(dispatch, {
                    TAG: /* SetIsRetry */2,
                    _0: retry
                  });
            }),
          is_create_trip_retry: state.is_create_trip_retry,
          set_is_create_trip_retry: (function (retry) {
              Curry._1(dispatch, {
                    TAG: /* SetIsCreateTripRetry */3,
                    _0: retry
                  });
            }),
          selected_vehicle: state.selected_vehicle,
          set_selected_vehicle: (function (selected_vehicle) {
              Curry._1(dispatch, {
                    TAG: /* SetSelectedVehicle */5,
                    _0: selected_vehicle
                  });
            }),
          selected_vehicle_fare: state.selected_vehicle_fare,
          set_selected_vehicle_fare: (function (selected_vehicle_fare) {
              Curry._1(dispatch, {
                    TAG: /* SetSelectedVehicleFare */6,
                    _0: selected_vehicle_fare
                  });
            }),
          selected_goods_type: state.selected_goods_type,
          set_selected_goods_type: (function (selected_goods_type) {
              Curry._1(dispatch, {
                    TAG: /* SetSelectedGoodsType */7,
                    _0: selected_goods_type
                  });
            }),
          customer_details: state.customer_details,
          location_bound: state.location_bound,
          set_location_bound: (function (location_bound) {
              Curry._1(dispatch, {
                    TAG: /* SetLocationBound */9,
                    _0: location_bound
                  });
            }),
          restriction_bound: state.restriction_bound,
          set_restriction_bound: (function (restriction_bound) {
              Curry._1(dispatch, {
                    TAG: /* SetRestrictionnBound */10,
                    _0: restriction_bound
                  });
            }),
          vehicle_details: state.vehicle_details,
          set_vehicle_details: (function (vehicle_details) {
              Curry._1(dispatch, {
                    TAG: /* SetVehicleDetails */11,
                    _0: vehicle_details
                  });
            }),
          restricted_vehicles: state.restricted_vehicles,
          set_restricted_vehicles: (function (restricted_vehicles) {
              Curry._1(dispatch, {
                    TAG: /* SetRestrictedVehicles */12,
                    _0: restricted_vehicles
                  });
            }),
          quotation: state.quotation,
          set_quotation: (function (quotation) {
              Curry._1(dispatch, {
                    TAG: /* SetQuotation */13,
                    _0: quotation
                  });
            }),
          vehicle_results: state.vehicle_results,
          set_vehicles_result: (function (vehicle_results) {
              Curry._1(dispatch, {
                    TAG: /* SetVehicleResult */14,
                    _0: vehicle_results
                  });
            }),
          disabled_trip_creation: state.disabled_trip_creation,
          set_disabled_trip_creation: (function (status) {
              Curry._1(dispatch, {
                    TAG: /* SetDisableTripCreation */15,
                    _0: status
                  });
            })
        };
}

function addressProviderValue(state, dispatch) {
  return {
          is_serviceable_pickup: state.is_serviceable_pickup,
          is_serviceable_dropoff: state.is_serviceable_dropoff,
          set_is_serviceable_pickup: (function ($$location) {
              Curry._1(dispatch, {
                    TAG: /* SetIsServiceablePickup */0,
                    _0: $$location
                  });
            }),
          set_is_serviceable_dropoff: (function ($$location) {
              Curry._1(dispatch, {
                    TAG: /* SetIsServiceableDropoff */1,
                    _0: $$location
                  });
            }),
          sender: state.sender,
          set_sender: (function (sender) {
              Curry._1(dispatch, {
                    TAG: /* SetSender */2,
                    _0: sender
                  });
            }),
          receiver: state.receiver,
          set_receiver: (function (receiver) {
              Curry._1(dispatch, {
                    TAG: /* SetReceiver */3,
                    _0: receiver
                  });
            })
        };
}

function createBookingObject(query_params, waypoint) {
  return {
          pickup_address: {
            landmark: Belt_Option.getWithDefault(query_params.from_landmark, ""),
            location: {
              lat: optionStringtoFloat(query_params.from_lat),
              lng: optionStringtoFloat(query_params.from_long)
            },
            extended_address: {
              state: undefined,
              city: undefined,
              pincode: undefined,
              locality: undefined,
              sub_locality: undefined
            }
          },
          drop_address: {
            landmark: Belt_Option.getWithDefault(query_params.to_landmark, ""),
            location: {
              lat: optionStringtoFloat(query_params.to_lat),
              lng: optionStringtoFloat(query_params.to_long)
            },
            extended_address: {
              state: undefined,
              city: undefined,
              pincode: undefined,
              locality: undefined,
              sub_locality: undefined
            }
          },
          name: waypoint ? query_params.receiver_name : query_params.sender_name,
          number: waypoint ? query_params.receiver_mobile : query_params.sender_mobile,
          house: waypoint ? query_params.to_house : query_params.from_house
        };
}

function locationBoundPayload(lat, $$long) {
  var payload = {};
  payload["lat"] = lat;
  payload["long"] = $$long;
  return payload;
}

function locationBoundPayloadFromQueryParam(query_params) {
  var payload = {};
  payload["lat"] = optionStringtoFloat(query_params.from_lat);
  payload["long"] = optionStringtoFloat(query_params.from_long);
  return payload;
}

function handleRestrictedVehicles(location_type, latLng, restrictionBounds) {
  var restricted_vehicles = [];
  Js_array.forEach((function (e) {
          switch (location_type) {
            case "Drop" :
                var match = e.polygon;
                if (typeof match === "number") {
                  return ;
                }
                switch (match.TAG | 0) {
                  case /* PickUp */0 :
                      return ;
                  case /* Drop */1 :
                  case /* Both */2 :
                      break;
                  
                }
                if (GeoLocationHelper$PorterinFeature.isCoordsUnderPolygon(match._0, latLng)) {
                  return Js_array.forEach((function (id) {
                                Js_array.push(id, restricted_vehicles);
                              }), e.vehicle_ids);
                } else {
                  return ;
                }
            case "PickUp" :
                var match$1 = e.polygon;
                if (typeof match$1 === "number") {
                  return ;
                }
                switch (match$1.TAG | 0) {
                  case /* Drop */1 :
                      return ;
                  case /* PickUp */0 :
                  case /* Both */2 :
                      break;
                  
                }
                if (GeoLocationHelper$PorterinFeature.isCoordsUnderPolygon(match$1._0, latLng)) {
                  return Js_array.forEach((function (id) {
                                Js_array.push(id, restricted_vehicles);
                              }), e.vehicle_ids);
                } else {
                  return ;
                }
            default:
              return ;
          }
        }), restrictionBounds);
  return restricted_vehicles;
}

function filterBasedOnAnotherArray(arr1, arr2) {
  return Js_array.filter((function (elem) {
                return !Js_array.includes(elem, arr2);
              }), arr1);
}

function quotation_payload(restricted_vehicles, all_vehicles, query_params, sender, receiver, geo_region_id) {
  var vehicles = all_vehicles !== undefined ? all_vehicles.vehicles.vehicle_ids : [];
  return {
          vehicle_ids: filterBasedOnAnotherArray(vehicles, restricted_vehicles),
          order: {
            customer_mobile: Belt_Option.getWithDefault(query_params.sender_mobile, ""),
            geo_region_id: geo_region_id,
            from_address_lat: sender.pickup_address.location.lat,
            from_address_long: sender.pickup_address.location.lng,
            to_address_lat: receiver.drop_address.location.lat,
            to_address_long: receiver.drop_address.location.lng,
            waypoints_attributes: [],
            value_added_services: [],
            payment_mode: "cash",
            business_order_info: undefined,
            use_porter_credits: false
          },
          selected_vehicle_id: undefined,
          service_type: "TRUCKS"
        };
}

function findSpecs(vehicle_details, key) {
  return Belt_Option.getWithDefault(Js_array.find((function (item) {
                    return item.key.toLowerCase() === key.toLowerCase();
                  }), vehicle_details), {
              key: "",
              value: ""
            }).value;
}

function vehicleFareBreakdown(quotation, vehicle_id) {
  var vehicle_fare_breakup = Js_array.find((function (breakdown) {
          return breakdown.vehicle_id === vehicle_id;
        }), quotation.vehicle_wise_quotations);
  if (vehicle_fare_breakup !== undefined) {
    return vehicle_fare_breakup.bill_details;
  }
  
}

function vehicleFareInfo(quotation, vehicle_id) {
  var vehicle_fare_breakup = Js_array.find((function (breakdown) {
          return breakdown.vehicle_id === vehicle_id;
        }), quotation.vehicle_wise_quotations);
  if (vehicle_fare_breakup !== undefined) {
    return vehicle_fare_breakup.fare_info;
  }
  
}

function vehicleFare(quotation, vehicle_id) {
  var fare_breakdown = vehicleFareBreakdown(quotation, vehicle_id);
  if (fare_breakdown !== undefined) {
    return String(fare_breakdown.net_fare);
  } else {
    return String(0.0);
  }
}

function vehicleQuotationUuid(quotation, vehicle_id) {
  var vehicle_quotation = Js_array.find((function (vehicle_wise_quotations) {
          return vehicle_wise_quotations.vehicle_id === vehicle_id;
        }), quotation.vehicle_wise_quotations);
  if (vehicle_quotation !== undefined) {
    return vehicle_quotation.quotation_uuid;
  } else {
    return "";
  }
}

function vehicleDiscount(quotation, vehicle_id) {
  var fare_breakdown = vehicleFareBreakdown(quotation, vehicle_id);
  if (fare_breakdown === undefined) {
    return ;
  }
  var discount = fare_breakdown.fare_breakup.reduce((function (acc, item) {
          if (typeof item === "number") {
            return 0.0;
          } else if (item.TAG === /* CouponDiscount */3) {
            return acc + item._0.value;
          } else {
            return 0.0;
          }
        }), 0.0);
  if (discount !== 0.0) {
    return String(discount);
  }
  
}

function vehicleGoldDiscount(quotation, vehicle_id) {
  var fare_info = vehicleFareInfo(quotation, vehicle_id);
  var goldDiscount = fare_info !== undefined ? fare_info.subscription_discount : undefined;
  if (goldDiscount !== undefined) {
    return String(goldDiscount);
  }
  
}

function vehicleWithoutDiscount(quotation, vehicle_id) {
  var fare_breakdown = vehicleFareBreakdown(quotation, vehicle_id);
  if (fare_breakdown === undefined) {
    return ;
  }
  var discount = fare_breakdown.fare_breakup.reduce((function (acc, item) {
          if (typeof item === "number") {
            return 0.0;
          }
          switch (item.TAG | 0) {
            case /* PorterGoldSavings */2 :
            case /* CouponDiscount */3 :
                return acc + item._0.value;
            default:
              return 0.0;
          }
        }), 0.0);
  var val = vehicleFareBreakdown(quotation, vehicle_id);
  var fare = val !== undefined ? val.net_fare : 0.0;
  if (discount !== 0.0) {
    return (discount + fare).toFixed(2);
  }
  
}

function defaultGoodsType(selected_goods_type) {
  if (selected_goods_type !== undefined) {
    return selected_goods_type;
  } else {
    return {
            id: 1,
            name: "Timber/Furniture"
          };
  }
}

function getPrimarySecondaryAddress(str) {
  var splitStr = Js_string.split(",", str);
  var primary = splitStr[0];
  var secondary = Js_string.replace("" + primary + ",", "", str);
  return [
          primary,
          secondary
        ];
}

function createTripPayload(sender, receiver, selected_goods_type, geo_region_id, selected_vehicle, vehicle_results) {
  var match = getPrimarySecondaryAddress(sender.pickup_address.landmark);
  var match$1 = getPrimarySecondaryAddress(receiver.drop_address.landmark);
  var quotation_uuid;
  if (vehicle_results !== undefined) {
    var vehicle_quotation = Js_array.find((function (vehicle) {
            return vehicle.vehicle_id === selected_vehicle;
          }), vehicle_results);
    quotation_uuid = vehicle_quotation !== undefined ? vehicle_quotation.quotation_uuid : "";
  } else {
    quotation_uuid = "";
  }
  return {
          order: {
            geo_region_id: geo_region_id,
            vehicle_id: selected_vehicle,
            pickup_name: Belt_Option.getWithDefault(sender.name, ""),
            pickup_phone_number: Belt_Option.getWithDefault(sender.number, ""),
            from_address_lat: sender.pickup_address.location.lat,
            from_address_long: sender.pickup_address.location.lng,
            from_address_doorstep: sender.house,
            from_address_components: [sender.pickup_address.landmark],
            from_address_details: {
              locality: sender.pickup_address.extended_address.locality,
              sub_locality: sender.pickup_address.extended_address.sub_locality
            },
            from_address: {
              title: match[0],
              subtitle: match[1]
            },
            receiver_name: Belt_Option.getWithDefault(receiver.name, Belt_Option.getWithDefault(sender.name, "")),
            receiver_mobile_number: Belt_Option.getWithDefault(receiver.number, Belt_Option.getWithDefault(sender.number, "")),
            to_address_lat: receiver.drop_address.location.lat,
            to_address_long: receiver.drop_address.location.lng,
            to_address_doorstep: receiver.house,
            to_address_components: [receiver.drop_address.landmark],
            to_address_details: {
              locality: receiver.pickup_address.extended_address.locality,
              sub_locality: receiver.pickup_address.extended_address.sub_locality
            },
            to_address: {
              title: match$1[0],
              subtitle: match$1[1]
            },
            goods_type_info: {
              business_types_id: selected_goods_type.id,
              business_type_description: selected_goods_type.name,
              quantity_of_goods: "Loose"
            },
            payment_mode: "cash",
            use_porter_credits: false,
            customer_location_lat: sender.pickup_address.location.lat,
            customer_location_long: sender.pickup_address.location.lng,
            try_book_till: true,
            pickup_in_mins: 20,
            fs_info: {
              fare_type: "on_demand",
              quotation_uuid: quotation_uuid
            }
          }
        };
}

function getLocaleCookie(param) {
  return CookieHelpers$PorterinUtils.getCookie("NEXT_LOCALE");
}

function allocationLinkRedirect(crn) {
  JsBindings$PorterinUtils.redirect(Config$PorterinUtils.oms_url + ("/" + CookieHelpers$PorterinUtils.getCookie("NEXT_LOCALE") + "/track-order?crn=") + crn);
}

function courierTrackingLinkRedirect(crn) {
  JsBindings$PorterinUtils.redirect(Config$PorterinUtils.newInitiativesUrl + "track-courier-order?source=website&crn=" + crn);
}

function convertPageProps(data) {
  return {
          agreedDocs: data.agreed_docs.map(function (doc) {
                return {
                        docType: doc.doc_type,
                        docUrl: doc.doc_url,
                        createdAt: doc.created_at,
                        updatedAt: doc.updated_at
                      };
              }),
          tncUrl: data.tnc_url,
          privacyPolicyUrl: data.privacy_policy_url
        };
}

export {
  optionStringtoFloat ,
  optionStringtoInt ,
  createDilPayload ,
  orderReviewProviderValue ,
  addressProviderValue ,
  createBookingObject ,
  locationBoundPayload ,
  locationBoundPayloadFromQueryParam ,
  handleRestrictedVehicles ,
  filterBasedOnAnotherArray ,
  quotation_payload ,
  findSpecs ,
  vehicleFareBreakdown ,
  vehicleFareInfo ,
  vehicleFare ,
  vehicleQuotationUuid ,
  vehicleDiscount ,
  vehicleGoldDiscount ,
  vehicleWithoutDiscount ,
  defaultGoodsType ,
  getPrimarySecondaryAddress ,
  createTripPayload ,
  getLocaleCookie ,
  allocationLinkRedirect ,
  courierTrackingLinkRedirect ,
  convertPageProps ,
}
/* dayjs Not a pure module */
